import React, { useState, useEffect, useMemo } from "react";
import { message, Progress, Spin } from "antd";
import useLogout from "../useLogout";
import DemoColumn from "./tester_stats";
import "../user/profileRoleBased.css";

const duplicateMonthlyCount = process.env.REACT_APP_API_SpecialDuplicateOTPCurrentMonth;
const dailyOTPCount = process.env.REACT_APP_API_SpecialOTPToday;
const monthlyOTPCount = process.env.REACT_APP_API_SpecialOTPCurrentMonth;
const previousMonthOTPCount = process.env.REACT_APP_API_SpecialOTPLastMonth;
const configSettingAPI = process.env.REACT_APP_ConfigSetting;
const bonusApi = process.env.REACT_APP_API_BonusURL;

const Testers = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const [dailyCount, setDailyCount] = useState(0);
  const [lowerLimitPayout, setLowerLimitPayout] = useState();
  const [bonusUSD, setBonusUSD] = useState();
  const [monthlyCount, setMonthlyCount] = useState(0);
  const [previousMonthCount, setPreviousMonthCount] = useState(0);
  const [duplicateMonthCount, setDuplicateMonthCount] = useState(0);
  const [paymentRate, setPaymentRate] = useState(0.01);
  const [loading, setLoading] = useState(true);

  const logout = useLogout();

  useEffect(() => {
    fetchOTPData();
  }, []);

  const storedUser = localStorage.getItem("user");
  const user = JSON.parse(storedUser);

  const fetchOTPData = async () => {
    try {
      setLoading(true);
      const userId = user.userId;

      // Fetch daily count
      const dailyResponse = await fetch(`${dailyOTPCount}/${userId}`);
      const dailyData = await dailyResponse.json();

      if (dailyData.inactive) {
        logout();
      } else {
        setDailyCount(dailyData.otp_today);
      }

      // Fetch previous month's count
      const previousMonthCountResponse = await fetch(
        `${previousMonthOTPCount}/${userId}`
      );
      const prevMonthData = await previousMonthCountResponse.json();
      if (prevMonthData.inactive) {
        logout();
      } else {
        setPreviousMonthCount(prevMonthData.otp_current_month);
      }

      // Fetch monthly count
      const monthlyResponse = await fetch(`${monthlyOTPCount}/${userId}`);
      const monthlyData = await monthlyResponse.json();
      if (monthlyData.inactive) {
        logout();
      } else {
        setMonthlyCount(monthlyData.otp_current_month);
      }

      const monthlyDuplicateResponse = await fetch(
        `${duplicateMonthlyCount}/${userId}`
      );
      const monthlyDuplicateData = await monthlyDuplicateResponse.json();
      if (monthlyDuplicateData.inactive) {
        logout();
      } else {
        setDuplicateMonthCount(
          monthlyDuplicateData.duplicate_otp_current_month
        );
      }
      // Fetch bonus details
      const bonusResponse = await fetch(`${bonusApi}/${userId}`);
      const bonusData = await bonusResponse.json();

      console.log("bonusData", bonusData);

      // Parse the body string into a JavaScript object
      const bodyObject = JSON.parse(bonusData.body);

      console.log("bodyObject", bodyObject);
      console.log("bodyObject.current_month_bonus", bodyObject.current_month_bonus);

      const currentBonus = bodyObject ? bodyObject.current_month_bonus : bonusData.current_month_bonus;

      console.log("current_month_bonus", currentBonus);
      setBonusUSD(currentBonus);

      const configSetting = await fetch(configSettingAPI);
      const bonusLimit = await configSetting.json();
      // setBonusUSD(bonusLimit.body.bonus_limit);
      setLowerLimitPayout(bonusLimit.body.payout_lower_limit);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const calculateValidOTPsAndPayment = (monthlyCount, duplicateMonthCount) => {
    const validOTPs = monthlyCount - duplicateMonthCount;
    let payment = validOTPs * paymentRate;
    console.log("payment", payment);

    return { validOTPs, payment };
  };

  const { validOTPs, payment } = useMemo(
    () => calculateValidOTPsAndPayment(monthlyCount, duplicateMonthCount),
    [monthlyCount, duplicateMonthCount]
  );

  const progressPercent = Math.min(Math.round((validOTPs / 5000) * 100), 100);

  return (
    <>
      {contextHolder}
      <div className="profile-rb">
        <div className="profile-rb-main">
          <h1 className="profile-rb-title">Your Dashboard</h1>
          <p className="profile-rb-subtitle">
            Overview of your testing activity and earnings
          </p>

          <div className="profile-rb-alert profile-rb-alert-info">
            If your valid OTP count for the month is less than 5000, the payment
            will be sent next month.
          </div>
          <div className="profile-rb-alert profile-rb-alert-warning">
            Payment is made only to those generating a minimum of 5000 OTPs per
            month. Failure to maintain this for three consecutive months may
            result in account suspension.
          </div>

          <Spin spinning={loading} size="large">
            <div className="profile-rb-stats">
              <div className="profile-rb-stat-card">
                <div className="profile-rb-stat-label">Tests Today</div>
                <div className="profile-rb-stat-value profile-rb-stat-value-success">
                  {dailyCount}
                </div>
              </div>
              <div className="profile-rb-stat-card">
                <div className="profile-rb-stat-label">Tests This Month</div>
                <div className="profile-rb-stat-value profile-rb-stat-value-success">
                  {monthlyCount}
                </div>
              </div>
              <div className="profile-rb-stat-card profile-rb-stat-danger">
                <div className="profile-rb-stat-label">Duplicates This Month</div>
                <div className="profile-rb-stat-value profile-rb-stat-value-danger">
                  {duplicateMonthCount}
                </div>
              </div>
              <div className="profile-rb-stat-card profile-rb-stat-success">
                <div className="profile-rb-stat-label">Valid Tests This Month</div>
                <div className="profile-rb-stat-value profile-rb-stat-value-success">
                  {validOTPs}
                </div>
              </div>
              <div className="profile-rb-stat-card profile-rb-stat-warning">
                <div className="profile-rb-stat-label">Total Payment This Month</div>
                <div className="profile-rb-stat-value">
                  ${(payment + (bonusUSD || 0)).toFixed(2)}
                  <span className="profile-rb-stat-suffix">USD</span>
                </div>
                <div
                  style={{
                    marginTop: 8,
                    fontSize: "0.75rem",
                    color: "#64748b",
                  }}
                >
                  Base: ${payment.toFixed(2)} · Bonus: $
                  {(bonusUSD || 0).toFixed(2)}
                </div>
              </div>
              <div className="profile-rb-stat-card">
                <div className="profile-rb-stat-label">Previous Month</div>
                <div className="profile-rb-stat-value profile-rb-stat-value-warning">
                  {previousMonthCount}
                </div>
              </div>
              <div className="profile-rb-stat-card">
                <div className="profile-rb-stat-label">Rate</div>
                <div
                  className="profile-rb-stat-value"
                  style={{ fontSize: "1rem" }}
                >
                  ${paymentRate}/OTP
                </div>
              </div>
              <div className="profile-rb-stat-card">
                <div className="profile-rb-stat-label">Target Progress (5000)</div>
                <div
                  className="profile-rb-stat-value"
                  style={{
                    color: validOTPs >= 5000 ? "#059669" : "#dc2626",
                  }}
                >
                  {validOTPs}
                  <span className="profile-rb-stat-suffix">/ 5000</span>
                </div>
                <div className="profile-rb-progress-wrap">
                  <Progress
                    percent={progressPercent}
                    status={validOTPs >= 5000 ? "success" : "active"}
                    strokeColor={validOTPs >= 5000 ? "#10b981" : "#38bdf8"}
                    size="small"
                    showInfo={false}
                  />
                </div>
              </div>
            </div>
          </Spin>

          <DemoColumn />
        </div>
      </div>
    </>
  );
};
export default Testers;
